<template>
  <el-select
    :model-value="modelValue"
    :placeholder="placeholder"
    size="large"
    class="workflow-dropdown"
    @update:model-value="$emit('update:modelValue', $event)"
  >
    <el-option
      v-for="item in options"
      :key="item[valueFieldName]"
      :label="item[labelFieldName]"
      :value="item[valueFieldName]"
    />
  </el-select>
</template>

<script>
export default {
  name: 'WorkflowDropdown',
  props: {
    modelValue: {
      type: [String, Number],
      default: ''
    },
    placeholder: {
      type: String,
      default: 'Please select'
    },
    options: {
      type: Array,
      default: () => []
    },
    labelFieldName: {
      type: String,
      required: true
    },
    valueFieldName: {
      type: String,
      required: true
    }
  },
  emits: ['update:modelValue']
};
</script>

<style scoped>
.workflow-dropdown {
  width: 100%;
}
</style>
